import { Button, Popover, Position } from "@blueprintjs/core"
import { NavLink } from "react-router-dom"
import { HasId, IPost } from "src/libs/interfaces/layouts"
import { title } from "src/libs/layouts"
import { __, jsonToData } from "src/libs/utilities"
import { getDownload } from "src/libs/utilities/getDownloadFile"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import * as XLSX from 'xlsx'
import { actions } from "../../data/actions"
import { GET_TEST_ACTION, GET_TEST_USER_RESULTS_ACTION } from "../../data/actionTypes"
import { IPETest } from "../../data/interfaces"
import { getAnswerCategoryData } from "../../data/utils/getCVGData"

/* Protopia Ecosystem component */
export interface ITestResultProps {
   item: any
}
const TestResultButton = (props: ITestResultProps): JSX.Element => {
    const PETestCategory : IPost[] = useDataStore((state: any) => state.PETestCategory)
    const onDownload = ( ) => {
        // console.log( `download User: ${props.item.display_name} ` )
        // console.log( props.item )
        
        actions(GET_TEST_ACTION, {id: -1})
            .then(() => {
                actions(
                    GET_TEST_USER_RESULTS_ACTION,
                    {
                        user_id: props.item.id
                    }
                )
                .then((res: any[]) => {
                    // console.log( res )
                    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
                    const fileExtension = '.xlsx'
                    let sheets: any = {}
                    let sheetNames: string[] = []
                    let userName: string = ""

                    res.forEach(r => {
                        let cats : any[] = []
                        let test:IPETest    = (useDataStore.getState().PETest || []).find( (t: HasId) => t.id === r.test_id)
                        const csvData       = getAnswerCategoryData(r.results, test)
                        userName            = r.user.display_name 
                        const testTitle     = test.title

                        csvData.forEach(c => {
                            if(!cats[ c.cat_id ]) {
                                cats[ c.cat_id ] = { 
                                    [__("Answer")]: PETestCategory.find(tc => tc.id === c.cat_id)?.title || c.cat_id, 
                                    [__("Value")] : 0
                                }
                            }
                            cats[ c.cat_id ][__("Value")] += Number(c.value)
                        })
                        cats = cats.filter( c => !!c)
                        console.log( cats )
                        const ws = XLSX.utils.json_to_sheet( cats, )
                        sheetNames.push( testTitle )
                        sheets[testTitle] = ws
                        console.log( ws )
                    }) 
                    const wb = { Sheets: sheets, SheetNames: sheetNames }
                    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array', Props:{Author: title(), Title : "Result of tests"} })
                    const data = new Blob([excelBuffer], {type: fileType})
                    getDownload(data, "testResult_" + userName + fileExtension)
                })
            })
    }
    return <div className="d-flex strob01">    
        <NavLink to={`${props.item.id}`} className='w-100 flex-grow-100'>
            <Button fill minimal alignText="left" className="btn-stretch user p-0">
                <div className="w-100 d-flex align-items-center">
                    <div className="avatar thumbnail" style={{backgroundImage:`url(${ props.item.avatar})`, width: 50, height: 50 }} />
                    <div className="d-flex w-100 p-3 ">
                        { props.item.display_name }    
                    </div>
                </div>            
            </Button>
        </NavLink> 
        <div className="min-w-50 flex-centered h-100 small ">
            {
               jsonToData(props.item.user_descr).age
            }
        </div>
        <div className="min-width-250 d-flex align-items-center h-100 small ">
            {
               jsonToData(props.item.user_descr).school
            }
        </div>
        <Popover
            interactionKind="hover"
            position={Position.TOP_RIGHT}
            content={
                <div className="p-3 letter-spacing-2">
                    {__("Download XLS")}
                </div>
            }
        >
            <Button minimal  onClick={() => onDownload( )} className="h-100">
                <i className="far fa-file-excel fa-1x my-2 mx-1 opacity_75"></i>
            </Button>
        </Popover>
    </div>
}
export default TestResultButton